const state = {
  uploadImage: [],
  sendPhotoLater: true,
  takePhotoWithGuidedCamera: false,
  otherListingUrl: '',
}

const getters = {
  uploadImage (state) {
    return state.uploadImage
  },
  sendPhotoLater (state) {
    return state.sendPhotoLater
  },
  takePhotoWithGuidedCamera (state) {
    return state.takePhotoWithGuidedCamera
  },
  otherListingUrl (state) {
    return state.otherListingUrl
  },
}
const actions = {
  setUploadedImages (context, data) {
    context.commit('setUploadedImages', data)
  },
  clearImages (context) {
    context.commit('clearImages')
  },
  async clearImagesWithPersistence () {
    // Import UploadPersistenceService dynamically to avoid circular dependency
    localStorage.removeItem('photoUploadState')
    const { default: UploadPersistenceService } = await import('@/helper/upload-persistence')
    await UploadPersistenceService.clearAllFileData()
  },
  setSendPhotoLater (context, data) {
    context.commit('setSendPhotoLater', data)
  },
  clearSendPhotoLater (context) {
    context.commit('clearSendPhotoLater')
  },
  setTakePhotoWithGuidedCamera (context, data) {
    context.commit('setTakePhotoWithGuidedCamera', data);
  },
  setOtherListingUrl (context, data) {
    context.commit('setOtherListingUrl', data);
  },
}

const mutations = {
  setUploadedImages (state, payload) {
    state.uploadImage = payload
  },
  clearImages (state) {
    state.uploadImage = []
  },
  setSendPhotoLater (state, payload) {
    state.sendPhotoLater = payload
  },
  clearSendPhotoLater (state) {
    state.sendPhotoLater = true
  },
  setTakePhotoWithGuidedCamera (state, data) {
    state.takePhotoWithGuidedCamera = data
  },
  setOtherListingUrl (state, data) {
    state.otherListingUrl = data
  },
}
export default {
  state,
  getters,
  actions,
  mutations
}